<template>

  <div>

    <div class="ui grid animated fadeIn">

      <div class="sixteen wide column">

        <div class="ui segment" :class="{ loading }" style="min-height: 150px; padding: 20px !important;">        

          <button v-if="showAddButton" class="ui mini basic button" @click="onAddFile()">
            <i class="plus blue icon"></i> Adicionar
          </button>

          <div v-if="!loading && files.length == 0" class="grey text m-t-20">
            <i class="info circle icon"></i> Nenhum arquivo adicionado
          </div>

          <div v-else class="ui basic segment">
            <table class="ui very basic selectable celled table">
              <thead class="desktop-only">
                <tr>
                  <th>Usuário</th>
                  <th>Nome do arquivo</th>
                  <th>Categoria</th>
                  <th>Envio</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="file in files">
                  <td><strong class="mobile-only">Usuário: </strong>{{ file.userName }}</td>
                  <td><strong class="mobile-only">Nome do arquivo: </strong><a>{{ file.fileName }}</a></td>
                  <td><strong class="mobile-only">Categoria: </strong>{{ getCategoryName(file.categoria) }}</td>
                  <td><strong class="mobile-only">Envio: </strong>{{ formatDate(file.data) }}</td>              
                  <td>
                    <button class="ui mini basic button" 
                      :class="{ loading: file.idFile == downloadingFileId }"
                      @click="onDownload(file)">
                      <i class="download blue icon"></i>
                      Baixar
                    </button>              
                    <button v-if="$store.state.user.id == file.userId" class="ui mini basic button m-l-10" 
                      :class="{ loading: file.idFile == removingFileId }"
                      @click="onRemove(file)">
                      <i class="times red icon"></i>
                      Remover
                    </button>
                  </td>
                </tr>                
              </tbody>
            </table>
          </div>

        </div>

      </div>

    </div>

    <div id="file-upload-dialog" class="ui small modal file-upload-modal">

      <div class="ui header">
        Adicionar anexo
      </div>

      <div class="content">

        <form class="ui form">
          <div class="fields">
            <div class="sixteen wide field">        
              <label>Arquivo</label>
              <input type="file" id="file" ref="file" @change="onFileChange()">
            </div>                   
          </div>    
          <div class="fields">
            <div class="sixteen wide field">
              <label>Categoria</label>
              <select class="ui fluid dropdown" v-model="categoryId">
                <option value="">Selecione...</option>
                <option v-for="category in categories" :value="category.id">{{ category.value }}</option>
              </select>
            </div>
          </div>                               
        </form>  

      </div>

      <div class="actions">
        <button class="ui cancel basic button">
          <i class="reply icon"></i>
          Sair
        </button>
        <button type="button" class="ui blue button" 
          :class="{ loading: uploading, disabled: !file || !categoryId }" 
          @click="onUploadFile()">
          <i class="upload icon"></i>
          Enviar
        </button>      
      </div>

    </div>

    <div id="remove-file-dialog" class="ui tiny modal remove-file-modal">

      <div class="ui header">
        Exclusão de Anexo
      </div>

      <div class="content">       

        <div class="ui orange message">
          <strong><i class="exclamation circle icon"></i>Atenção</strong>          
          <div class="m-t-15">
            Confirma exclusão do arquivo <strong>{{ selectedFile.fileName }}</strong> ?
          </div>
        </div> 

      </div>

      <div class="actions">
        <button class="ui cancel basic button">
          <i class="reply icon"></i>
          Cancelar
        </button>
        <button type="button" class="ui red basic button" @click="onConfirmRemove()">
          <i class="times icon"></i>
          Remover
        </button>
      </div>

    </div>

  </div>

</template>

<script>
  
  import config from "../../../../config.json"
  import { Message, moment, cleanSpecialChars } from "@/utils"  
  import { http, QuotationService, MessageService } from "@/services"

  export default {    

    data() {
      return {
        loading: false,
        uploading: false,
        files: [],
        categories: [],
        selectedFile: {},
        file: null,        
        downloadingFileId: "",
        removingFileId: "",
        categoryId: "",
      }
    },
    
    props: ["quotation"],    

    computed: {

      showAddButton() {

        if (!this.quotation.isOwner && !this.quotation.isApprover)
          return false

        if (this.quotation.isRevision || this.quotation.confirmed || this.quotation.canceled)
          return false 

        return true
      },
    },

    created() {
      this.loadFiles()
    },

    beforeDestroy() {
      $(".file-upload-modal").remove()
      $(".remove-file-modal").remove()      
    },

    methods: {

      onAddFile() {

        if (this.quotation.underMaintenance) {
          if (this.quotation.isOwner) {
            Message.info("Finalize a manutenção do orçamento antes de anexar arquivos")
          } else {
            Message.info("Orçamento em manutenção")
          }                 
          return
        }

        $("#file-upload-dialog").modal("show")
      },

      onFileChange() {
        this.file = this.$refs.file.files[0]
      },

      async onUploadFile() {

        this.uploading = true

        try {

          const fileName = this.cleanFileName(this.file.name)

          let formData = new FormData()

          formData.append("file", this.file, fileName)
          formData.append("origem", "ZP5")
          formData.append("idorigem", this.quotation.id)
          formData.append("categoria", this.categoryId)
          formData.append("userId", this.$store.state.user.id)
          formData.append("userName", this.$store.state.user.name)

          let headers = {}

          headers["x-access-token"] = this.$store.state.uploadToken
          headers["Content-Type"] = "multipart/form-data"		
          
          const fileUploadUrl = config.client.fileUploadApi + "/upload"
          const response = await http.post(fileUploadUrl, formData, { headers })

          if (response.status) {			

            await this.loadFiles()      
            
            await MessageService.create({
              subject: "Arquivo anexado",
              text: this.$store.state.user.name + " anexou o arquivo " + fileName,
              quotationId: this.quotation.id,              
            })

            $("#file-upload-dialog").modal("hide")

            Message.success("Arquivo adicionado com sucesso")

            this.file = null
            this.$refs.file.value = ""  
            this.categoryId = ""
            
            this.$emit("onUpload")

          } else {
            Message.warn(response.payload)
          }
          
        } catch (error) {
          this.fileUploadApiErrorHandler(error)
        }

        this.uploading = false
      },

      cleanFileName(name) {

        let cleanName = cleanSpecialChars(name)

        return cleanName.replace(/[^a-zA-Z0-9-_\.]/g, '')
      },

      async loadFiles() {

        this.loading = true

        try {

          if (this.$store.state.quotationsAttachmentsCategories.length > 0) {
            this.categories = this.$store.state.quotationsAttachmentsCategories            
          } else {
            this.categories = await QuotationService.getAttachmentsCategories()
            this.$store.commit("setQuotationsAttachmentsCategories", this.categories)
          }

          let headers = {}          

          headers["x-access-token"] = this.$store.state.uploadToken
          headers["Content-Type"] = "application/json"

          const body = {
            ParamList: {
              origem: "ZP5",
              idorigem: this.quotation.id,
            }
          }	

          const fileUploadUrl = config.client.fileUploadApi + "/list"

          this.files = await http.post(fileUploadUrl, body, { headers }).then((response) => response.message)
          
        } catch (error) {
          this.fileUploadApiErrorHandler(error)
        }

        this.loading = false
      },

      formatDate(date) {
        return moment(date).format("DD/MM/YYYY [às] HH:mm")
      },

      getCategoryName(id) {

        let name = ""

        this.categories.forEach((category) => {

          if (category.id == id)
            name = category.value	
        })	

        return name	
      },

      async onDownload(file) {

        if (this.downloadingFileId || this.removingFileId)
          return

        this.downloadingFileId = file.idFile

        try {

          let headers = {}

          headers["x-access-token"] = this.$store.state.uploadToken

          const downloadUrl = config.client.fileUploadApi + "/download/" + file.idFile

          const data = await http({ 
            method: "GET",  
            headers,
            url: downloadUrl, 
            responseType: "blob",              
          })

          const url = window.URL.createObjectURL(new Blob([data]))
          const link = document.createElement("a")

          link.href = url		  
          link.setAttribute("download", file.fileName)

          document.body.appendChild(link)

          link.click()	
          
        } catch (error) {
          this.fileUploadApiErrorHandler(error)
        }

        this.downloadingFileId = ""

      },

      onRemove(file) {

        if (this.downloadingFileId || this.removingFileId)
          return

        this.selectedFile = file

        $("#remove-file-dialog").modal("show")
      },

      async onConfirmRemove() {

        this.removingFileId = this.selectedFile.idFile

        $("#remove-file-dialog").modal("hide")

        try {

          let headers = {}

          headers["x-access-token"] = this.$store.state.uploadToken
          headers["Content-Type"] = "application/json"		

          const body = {
            ParamList: {
              origem: "ZP5",
              idFile: this.selectedFile.idFile,              
              idorigem: this.quotation.id,
            }
          }

          const response = await http({ 
            method: "DELETE", 
            headers,
            url: config.client.fileUploadApi + "/delete", 
            data: body,
          })

          if (response.status) {

            await this.loadFiles()            

            await MessageService.create({
              subject: "Exclusao de anexo",
              text: this.$store.state.user.name + " excluiu o arquivo " + this.cleanFileName(this.selectedFile.fileName),
              quotationId: this.quotation.id,              
            })

            Message.success("Arquivo removido com sucesso")

            this.$emit("onRemove")

          } else {

            Message.warn(response.payload)
          }
          
        } catch (error) {
          this.fileUploadApiErrorHandler(error)
        }
      },

      fileUploadApiErrorHandler(error) {

        if (error && error.response && error.response.data && error.response.data.message) {
          Message.warn(error.response.data.message)
        } else {
          this.$errorHandler(error)
        }
      },
    },

  }

</script>